import React, { useContext } from "react";
import "./App.css";
import Routes from "./AppRouter";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import {
  QueryClient,
  QueryClientProvider,
} from "@tanstack/react-query";
import { Loader } from "./Utils/Loader";
import { DataContext } from "./context/DataContext";

const queryClient = new QueryClient();
function App() {
  const { loader } = useContext(DataContext);
  return (
    <QueryClientProvider client={queryClient}>
      {" "}
      <Routes />
      <Loader loader={loader} />
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}

export default App;
